"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _reactUse = require("react-use");
var _formik = require("formik");
var _deprecatedProps = _interopRequireDefault(require("./deprecatedProps"));
var _index = require("../index");
var _helpers = require("../helpers");
var _excluded = ["name", "wrapped", "label", "labelAbove", "labelProps", "tooltipText", "info", "automationHook", "onFormikChange", "w", "labelW", "inputW", "mB", "labelWidth", "inputWidth", "width", "marginBottom", "isHighlighted", "debounce"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var propTypes = _objectSpread({
  /** The name attribute on the input is required */
  name: _propTypes["default"].string.isRequired,
  /** Wether to wrap this component in a wrapper that adds the label and error message */
  wrapped: _propTypes["default"].bool,
  /** If wrapped === true, the label text */
  label: _propTypes["default"].string,
  /** Wether the input is required or not */
  isRequired: _propTypes["default"].bool,
  /** If wrapped === true, the width of the label */
  labelW: _propTypes["default"].string,
  /** A short text hint that describes the expected value of the field */
  placeholder: _propTypes["default"].string,
  /** If wrapped === true, the width of the input */
  inputW: _propTypes["default"].string,
  /** If wrapped === true, wether the label should be above */
  labelAbove: _propTypes["default"].bool,
  /** Props to be passed on label */
  labelProps: _propTypes["default"].object,
  /** The width of the entire component */
  w: _propTypes["default"].string,
  /** Tooltip text to pass to the FieldWrapper */
  tooltipText: _propTypes["default"].string,
  /** Adds a margin bottom after the field */
  mB: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /** Description that appears under the field, explaining what it does */
  info: _propTypes["default"].string,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string,
  /** Extra function to call after the formik field is changed. Receives an object with value and event. */
  onFormikChange: _propTypes["default"].func,
  /** Specifies if the current field is highlighted */
  isHighlighted: _propTypes["default"].bool,
  /** Specifies the number of milliseconds for debounced searchTerm */
  debounce: _propTypes["default"].number
}, _deprecatedProps["default"]);
var InputFormik = function InputFormik(_ref) {
  var _event$target$value, _event$target;
  var name = _ref.name,
    _ref$wrapped = _ref.wrapped,
    wrapped = _ref$wrapped === void 0 ? true : _ref$wrapped,
    label = _ref.label,
    labelAbove = _ref.labelAbove,
    labelProps = _ref.labelProps,
    tooltipText = _ref.tooltipText,
    info = _ref.info,
    automationHook = _ref.automationHook,
    onFormikChange = _ref.onFormikChange,
    w = _ref.w,
    labelW = _ref.labelW,
    inputW = _ref.inputW,
    mB = _ref.mB,
    labelWidth = _ref.labelWidth,
    inputWidth = _ref.inputWidth,
    width = _ref.width,
    marginBottom = _ref.marginBottom,
    isHighlighted = _ref.isHighlighted,
    _ref$debounce = _ref.debounce,
    debounce = _ref$debounce === void 0 ? 300 : _ref$debounce,
    rest = _objectWithoutProperties(_ref, _excluded);
  (0, _helpers.useDeprecate)({
    width: width,
    inputWidth: inputWidth,
    labelWidth: labelWidth,
    marginBottom: marginBottom
  }, "InputFormik");
  var _useField = (0, _formik.useField)(name),
    _useField2 = _slicedToArray(_useField, 2),
    field = _useField2[0],
    meta = _useField2[1];
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    event = _useState2[0],
    setEvent = _useState2[1];
  var id = "".concat(name, "_input");
  var currentValue = isHighlighted ? field.value : (_event$target$value = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : field.value || "";
  var changeHandler = function changeHandler(e) {
    setEvent(e);
    onFormikChange === null || onFormikChange === void 0 ? void 0 : onFormikChange({
      value: e.target.value,
      event: e
    });
  };
  (0, _reactUse.useDebounce)(function () {
    if (event) {
      field.onChange(event);
      // This ensures that if the field.value is changed programatically,
      // it is not overwritten by the event
      setEvent(null);
    }
  }, debounce, [event]);
  return /*#__PURE__*/_react["default"].createElement(_index.ConditionalWrap, {
    condition: wrapped,
    wrap: function wrap(children) {
      return /*#__PURE__*/_react["default"].createElement(_index.FieldWrapper, {
        labelAbove: labelAbove,
        label: label,
        labelFor: id,
        error: meta.touched && meta.error,
        tooltipText: tooltipText,
        info: info,
        automationHook: automationHook,
        w: w || width /** TODO:  deprecate width */,
        labelW: labelW || labelWidth /** TODO:  deprecate labelWidth */,
        inputW: inputW || inputWidth /** TODO:  deprecate inputWidth */,
        mB: mB !== null && mB !== void 0 ? mB : marginBottom /** TODO:  deprecate marginBottom */,
        labelProps: _objectSpread({
          isHighlighted: isHighlighted
        }, labelProps)
      }, children);
    }
  }, /*#__PURE__*/_react["default"].createElement(_index.Input, _extends({}, field, {
    onChange: changeHandler,
    id: id,
    type: "text",
    variant: "filled",
    hasError: meta.touched && meta.error,
    width: !wrapped ? w : undefined,
    value: currentValue,
    isHighlighted: isHighlighted
  }, (0, _automationHooks.hook)(automationHook, "input"), rest)));
};
InputFormik.propTypes = propTypes;
var _default = exports["default"] = InputFormik;